import * as Types from '../../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type MaterialsQueryVariables = {};


export type MaterialsQuery = (
  { __typename?: 'Query' }
  & { materials: Array<(
    { __typename?: 'Material' }
    & Pick<Types.Material, '_id' | 'containerType' | 'label' | 'nettoWeight' | 'length' | 'width' | 'inactive'>
  )> }
);

export type DangerousGoodsQueryVariables = {};


export type DangerousGoodsQuery = (
  { __typename?: 'Query' }
  & { dangerousGoods: Array<(
    { __typename?: 'DangerousGood' }
    & Pick<Types.DangerousGood, 'unNumber' | 'description'>
  )> }
);

export type AddProvingMaterialMutationVariables = {
  provingId: Types.Scalars['ID'],
  input: Types.ProvingMaterialInput
};


export type AddProvingMaterialMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'addProvingMaterial'>
);

export type AddProvingMaterialsMutationVariables = {
  provingId: Types.Scalars['ID'],
  inputs: Array<Types.ProvingMaterialInput>
};


export type AddProvingMaterialsMutation = (
  { __typename?: 'Mutation' }
  & { addProvingMaterials: Array<(
    { __typename?: 'ProvingMaterial' }
    & Pick<Types.ProvingMaterial, '_id'>
  )> }
);

export type UpdateProvingMaterialMutationVariables = {
  provingId: Types.Scalars['ID'],
  batch: Array<Types.ProvingMaterialBatchInput>
};


export type UpdateProvingMaterialMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'updateProvingMaterial'>
);

export type DeleteProvingMaterialMutationVariables = {
  provingId: Types.Scalars['ID'],
  idsToDelete: Array<Types.Scalars['String']>
};


export type DeleteProvingMaterialMutation = (
  { __typename?: 'Mutation' }
  & { deleteProvingMaterial: Array<(
    { __typename?: 'ProvingMaterial' }
    & Pick<Types.ProvingMaterial, '_id'>
  )> }
);

export type ExportMaterialsToSapMutationVariables = {
  provingId: Types.Scalars['String'],
  materialIds: Array<Types.Scalars['String']>,
  outboundTransportSender?: Types.Maybe<Types.Scalars['String']>,
  outboundTransportRecipient?: Types.Maybe<Types.Scalars['String']>,
  returnTransportSender?: Types.Maybe<Types.Scalars['String']>,
  returnTransportRecipient?: Types.Maybe<Types.Scalars['String']>,
  outboundTransport?: Types.Maybe<Types.Scalars['Boolean']>,
  returnTransport?: Types.Maybe<Types.Scalars['Boolean']>
};


export type ExportMaterialsToSapMutation = (
  { __typename?: 'Mutation' }
  & Pick<Types.Mutation, 'exportMaterialsToSAP'>
);

export const MaterialsDocument = gql`
    query Materials {
  materials(filter: {inactive: {NEQ: true}}) {
    _id
    containerType
    label
    nettoWeight
    length
    width
    length
    inactive
  }
}
    `;

    export function useMaterialsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MaterialsQuery, MaterialsQueryVariables>) {
      return ApolloReactHooks.useQuery<MaterialsQuery, MaterialsQueryVariables>(MaterialsDocument, baseOptions);
    };
      export function useMaterialsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MaterialsQuery, MaterialsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<MaterialsQuery, MaterialsQueryVariables>(MaterialsDocument, baseOptions);
      };
      
export type MaterialsQueryHookResult = ReturnType<typeof useMaterialsQuery>;
export type MaterialsQueryResult = ApolloReactCommon.QueryResult<MaterialsQuery, MaterialsQueryVariables>;
export const DangerousGoodsDocument = gql`
    query DangerousGoods {
  dangerousGoods {
    unNumber
    description
  }
}
    `;

    export function useDangerousGoodsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DangerousGoodsQuery, DangerousGoodsQueryVariables>) {
      return ApolloReactHooks.useQuery<DangerousGoodsQuery, DangerousGoodsQueryVariables>(DangerousGoodsDocument, baseOptions);
    };
      export function useDangerousGoodsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DangerousGoodsQuery, DangerousGoodsQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<DangerousGoodsQuery, DangerousGoodsQueryVariables>(DangerousGoodsDocument, baseOptions);
      };
      
export type DangerousGoodsQueryHookResult = ReturnType<typeof useDangerousGoodsQuery>;
export type DangerousGoodsQueryResult = ApolloReactCommon.QueryResult<DangerousGoodsQuery, DangerousGoodsQueryVariables>;
export const AddProvingMaterialDocument = gql`
    mutation addProvingMaterial($provingId: ID!, $input: ProvingMaterialInput!) {
  addProvingMaterial(provingId: $provingId, input: $input)
}
    `;
export type AddProvingMaterialMutationFn = ApolloReactCommon.MutationFunction<AddProvingMaterialMutation, AddProvingMaterialMutationVariables>;

    export function useAddProvingMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProvingMaterialMutation, AddProvingMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<AddProvingMaterialMutation, AddProvingMaterialMutationVariables>(AddProvingMaterialDocument, baseOptions);
    };
export type AddProvingMaterialMutationHookResult = ReturnType<typeof useAddProvingMaterialMutation>;
export type AddProvingMaterialMutationResult = ApolloReactCommon.MutationResult<AddProvingMaterialMutation>;
export type AddProvingMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProvingMaterialMutation, AddProvingMaterialMutationVariables>;
export const AddProvingMaterialsDocument = gql`
    mutation addProvingMaterials($provingId: ID!, $inputs: [ProvingMaterialInput!]!) {
  addProvingMaterials(provingId: $provingId, inputs: $inputs) {
    _id
  }
}
    `;
export type AddProvingMaterialsMutationFn = ApolloReactCommon.MutationFunction<AddProvingMaterialsMutation, AddProvingMaterialsMutationVariables>;

    export function useAddProvingMaterialsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddProvingMaterialsMutation, AddProvingMaterialsMutationVariables>) {
      return ApolloReactHooks.useMutation<AddProvingMaterialsMutation, AddProvingMaterialsMutationVariables>(AddProvingMaterialsDocument, baseOptions);
    };
export type AddProvingMaterialsMutationHookResult = ReturnType<typeof useAddProvingMaterialsMutation>;
export type AddProvingMaterialsMutationResult = ApolloReactCommon.MutationResult<AddProvingMaterialsMutation>;
export type AddProvingMaterialsMutationOptions = ApolloReactCommon.BaseMutationOptions<AddProvingMaterialsMutation, AddProvingMaterialsMutationVariables>;
export const UpdateProvingMaterialDocument = gql`
    mutation updateProvingMaterial($provingId: ID!, $batch: [ProvingMaterialBatchInput!]!) {
  updateProvingMaterial(provingId: $provingId, batch: $batch)
}
    `;
export type UpdateProvingMaterialMutationFn = ApolloReactCommon.MutationFunction<UpdateProvingMaterialMutation, UpdateProvingMaterialMutationVariables>;

    export function useUpdateProvingMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProvingMaterialMutation, UpdateProvingMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateProvingMaterialMutation, UpdateProvingMaterialMutationVariables>(UpdateProvingMaterialDocument, baseOptions);
    };
export type UpdateProvingMaterialMutationHookResult = ReturnType<typeof useUpdateProvingMaterialMutation>;
export type UpdateProvingMaterialMutationResult = ApolloReactCommon.MutationResult<UpdateProvingMaterialMutation>;
export type UpdateProvingMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateProvingMaterialMutation, UpdateProvingMaterialMutationVariables>;
export const DeleteProvingMaterialDocument = gql`
    mutation deleteProvingMaterial($provingId: ID!, $idsToDelete: [String!]!) {
  deleteProvingMaterial(provingId: $provingId, idsToDelete: $idsToDelete) {
    _id
  }
}
    `;
export type DeleteProvingMaterialMutationFn = ApolloReactCommon.MutationFunction<DeleteProvingMaterialMutation, DeleteProvingMaterialMutationVariables>;

    export function useDeleteProvingMaterialMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteProvingMaterialMutation, DeleteProvingMaterialMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteProvingMaterialMutation, DeleteProvingMaterialMutationVariables>(DeleteProvingMaterialDocument, baseOptions);
    };
export type DeleteProvingMaterialMutationHookResult = ReturnType<typeof useDeleteProvingMaterialMutation>;
export type DeleteProvingMaterialMutationResult = ApolloReactCommon.MutationResult<DeleteProvingMaterialMutation>;
export type DeleteProvingMaterialMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteProvingMaterialMutation, DeleteProvingMaterialMutationVariables>;
export const ExportMaterialsToSapDocument = gql`
    mutation exportMaterialsToSAP($provingId: String!, $materialIds: [String!]!, $outboundTransportSender: String, $outboundTransportRecipient: String, $returnTransportSender: String, $returnTransportRecipient: String, $outboundTransport: Boolean, $returnTransport: Boolean) {
  exportMaterialsToSAP(provingId: $provingId, materialIds: $materialIds, outboundTransportSender: $outboundTransportSender, outboundTransportRecipient: $outboundTransportRecipient, returnTransportSender: $returnTransportSender, returnTransportRecipient: $returnTransportRecipient, outboundTransport: $outboundTransport, returnTransport: $returnTransport)
}
    `;
export type ExportMaterialsToSapMutationFn = ApolloReactCommon.MutationFunction<ExportMaterialsToSapMutation, ExportMaterialsToSapMutationVariables>;

    export function useExportMaterialsToSapMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportMaterialsToSapMutation, ExportMaterialsToSapMutationVariables>) {
      return ApolloReactHooks.useMutation<ExportMaterialsToSapMutation, ExportMaterialsToSapMutationVariables>(ExportMaterialsToSapDocument, baseOptions);
    };
export type ExportMaterialsToSapMutationHookResult = ReturnType<typeof useExportMaterialsToSapMutation>;
export type ExportMaterialsToSapMutationResult = ApolloReactCommon.MutationResult<ExportMaterialsToSapMutation>;
export type ExportMaterialsToSapMutationOptions = ApolloReactCommon.BaseMutationOptions<ExportMaterialsToSapMutation, ExportMaterialsToSapMutationVariables>;